












































   
import {Component, Vue} from "vue-property-decorator";
import SwiperCarousel from "@/components/SwiperCarousel.vue";
import "@/plugins/metaHeadful";

@Component({
  components: {
    SwiperCarousel
  }
})

export default class About extends Vue {



  /*mainCarousel: any = {
    slides: [
      {image: 'assets/static/pages/about/slide1.jpg'}
    ],
    breakpoints: {
      1280: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20
      }
    }
  };*/
  team: any[] = [
    {
      image: 'assets/static/pages/about/team/matteo-ranghetti.jpg',
      name: 'Matteo Ranghetti',
      role: 'Co-Founder & CEO'
    },
    {
      image: 'assets/static/pages/about/team/filippo-galanti.jpg',
      name: 'Filippo Galanti',
      role: 'Co-Founder & Business Development'
    },
    {
      image: 'assets/static/pages/about/team/andre-silva.jpg',
      name: 'Andre Luiz Silva',
      role: 'CTO & Wine Teller'
    },
    {
      image: 'assets/static/pages/about/team/simona-carbonaro.png',
      name: 'Simona Carbonaro',
      role: 'Digital Marketing'
    },
    {
      image: 'assets/static/pages/about/team/federico-gotz.jpg',
      name: 'Federico Luca Gotz',
      role: 'Content Creator & Winery Ambassador'
    },
    {
      image: 'assets/static/pages/about/team/anna-malacrida.png',
      name: 'Anna Malacrida',
      role: 'Winery Account & Customer Care'
    },
    {
      image: 'assets/static/pages/about/team/saverio-pizza.png',
      name: 'Saverio Pizza',
      role: 'Sales and Operations'
    },
    {
      image: 'assets/static/pages/about/team/martina-antuofermo.png',
      name: 'Martina Antuofermo',
      role: 'Social Media & Communications Strategy'
    },
    {
      image: 'assets/static/pages/about/team/carlo-rossi.png',
      name: 'Carlo Rossi Chauvenet',
      role: 'Co-Founder & Advisor'
    },
    {
      image: 'assets/static/pages/about/team/veronica-mariani.jpg',
      name: 'Veronica Mariani',
      role: 'Investor & Advisor'
    },
    {
      image: 'assets/static/pages/about/team/gianluca-cocco.jpg',
      name: 'Gianluca Cocco',
      role: 'Investor & Advisor'
    }
  ];
}
